'use client'

import { ITravelPointQuote } from '@repo/sdk'
import { Button, Separator } from '@repo/ui'
import { Control } from 'react-hook-form'

import { CalendarInput } from './calendar-input.tsx'
import { DateTimeInputProvider, useDateTimeInput } from './context.tsx'
import { DateTimeInputPopover } from './popover.tsx'
import { QuickSelectDateInput } from './quick-select.tsx'
import { TimesInput } from './times-input.tsx'

interface Props {
  className?: string
  control: Control<{ drops: ITravelPointQuote[] }>
  index: number
  isAdmin?: boolean
}

export const DateTimeInput = ({ className, ...props }: Props) => {
  return (
    <DateTimeInputProvider {...props}>
      <DateTimeInputPopover className={className}>
        <CalendarInput />
        <TimesInput />
        <Separator />
        <QuickSelectDateInput />
        <ActionButtons />
      </DateTimeInputPopover>
    </DateTimeInputProvider>
  )
}

const ActionButtons = () => {
  const {
    dateControl,
    dateState: [date],
    openState: [_, setOpen],
    timeControl,
    timeState: [time],
  } = useDateTimeInput()

  const handleSave = () => {
    dateControl.field.onChange(date)
    timeControl.field.onChange(time)

    setOpen(false)
  }

  return (
    <div className={'flex w-full justify-stretch gap-4'}>
      <Button
        className={'w-full'}
        onClick={() => {
          setOpen(false)
        }}
        variant={'ghost'}
      >
        Cancel
      </Button>
      <Button className={'w-full'} onClick={handleSave}>
        Save
      </Button>
    </div>
  )
}
